import { createHttpClient } from "./createHttpClient";
import { getReportingApiBaseUrl } from "../../config/apiBaseUrls";

export const reportingClient = createHttpClient({
  resolveBaseURL: getReportingApiBaseUrl,
});

